export const firebaseConfig = {
apiKey: "AIzaSyDcBcL7BrZxwBu2J-cxBLBChWxhhgxlSwU",
  authDomain: "testwrh-cms.firebaseapp.com",
  projectId: "testwrh-cms",
  storageBucket: "testwrh-cms.appspot.com",
  messagingSenderId: "354257854527",
  appId: "1:354257854527:web:79d5b7cabd89b0adbb188a",
  measurementId: "G-LY3G4HQSGG"
};